import { defineMessages } from 'react-intl';

export default defineMessages({
  subtotal: {
    id: 'shop.cart.subtotal',
    defaultMessage: 'Subtotal',
  },
  totalExTax: {
    id: 'shop.cart.totalExTax',
    defaultMessage: 'Order Total Excl. Tax',
  },
  exTax: {
    id: 'shop.cart.ExTax',
    defaultMessage: 'Excl. Tax',
  },
  inclTax: {
    id: 'shop.cart.IncTax',
    defaultMessage: 'Incl. Tax',
  },
  discountLabel: {
    id: 'shop.cart.discountLabel',
    defaultMessage: 'Discount',
  },
  appliedTax: {
    id: 'shop.cart.appliedTax',
    defaultMessage: 'Plus tax',
  },
  grandTotal: {
    id: 'shop.cart.grandTotal',
    defaultMessage: 'Order Total',
  },
  taxCheckout: {
    id: 'common.notices.taxCheckout',
    defaultMessage: 'Depending on your address tax may vary in the checkout',
  },
});
